<template>
  <transition name="fade" mode="out-in">
    <div v-if="resource.ready && selects.ready">
      <div class="card mb-5">
        <div class="card-title" v-once>
                    <span v-if="editing"
                    >Аренда – #{{ entry.id }} ({{
                        entry.product.name
                      }})</span
                    >
          <span v-else>Создать аренду</span>
        </div>

        <form class="spaced-y-4" @submit.prevent="submit">
          <div class="flex -mx-2">
            <select-field
                :filter-by="productsFilterBy"
                class="w-1/2 px-2"
                title="Товар"
                label="name"
                valueName="id"
                :options="selects.products"
                v-model="entry.product_id"
                :errors="errors.product_id"
                :clearable="false"
                required
            />

            <select-field
                class="w-1/2 px-2"
                title="Счет"
                label="name"
                valueName="id"
                :options="selects.accounts"
                v-model="entry.account_id"
                :errors="errors.account_id"
                :clearable="false"
                required
            />
          </div>

          <div class="flex -mx-2">
            <select-field
                class="w-1/2 px-2"
                title="Тип аренды"
                label="label"
                valueName="value"
                :options="selects.types"
                v-model="entry.type"
                :errors="errors.type"
                :clearable="false"
                required
            />
          </div>

          <div class="flex -mx-2">
            <search-select-field
                :filter-by="customersFilterBy"
                class="w-1/2 px-2"
                title="Клиент"
                label="label"
                valueName="id"
                :options="selects.customers"
                v-model="entry.customer_id"
                :errors="errors.customer_id"
                @input="setCustomer"
                :clearable="false"
                @search="fetchCustomers"
                required
            />

            <text-field
                class="w-1/2 px-2"
                title="Стоимость"
                v-model="entry.amount"
                :errors="errors.amount"
                required
            />
          </div>

          <div class="flex -mx-2">
            <select-field
                class="w-1/2 px-2"
                title="Продавец"
                label="full_name"
                valueName="id"
                v-if="
                                $auth.user().role.name == 'admin' ||
                                $auth.user().role.name == 'super-admin'
                            "
                :options="selects.sellers"
                v-model="entry.seller_id"
                :errors="errors.seller_id"
                :clearable="!editing"
            />

            <select-field
                class="w-1/2 px-2"
                title="Партнер"
                label="full_name"
                valueName="id"
                :options="selects.partners"
                v-model="entry.partner_id"
                :errors="errors.partner_id"
                v-if="entry.customer || editing"
                :disabled="editing"
                :clearable="!editing"
            />
          </div>

          <div class="flex -mx-2">
            <date-field
                class="w-1/2 px-2"
                title="Начало"
                v-model="entry.starts_at"
                format="Y-m-d H:i:00"
                :time="true"
                displayFormat="H:i d.m.Y"
                :errors="errors.starts_at"
            />

            <date-field
                class="w-1/2 px-2"
                title="Окончание"
                v-model="entry.ends_at"
                format="Y-m-d H:i:00"
                :time="true"
                displayFormat="H:i d.m.Y"
                :errors="errors.ends_at"
            />
          </div>

          <div v-if="editing" class="flex -mx-2">
            <date-field
                class="w-1/2 px-2"
                title="Дата возврата"
                v-model="entry.returned_at"
                format="Y-m-d H:i:00"
                :time="true"
                displayFormat="H:i d.m.Y"
                :errors="errors.returned_at"
            />
          </div>

          <hr class="mb-3"/>

          <button
              v-if="!editing || canUpdate"
              :disabled="saving"
              class="btn btn-primary"
          >
            Сохранить
          </button>

          <div class="inline-block" v-if="editing">
            <button
                @click.prevent="returnItem"
                v-show="!entry.is_returned"
                class="btn btn-blue"
            >
              Принять
            </button>

            <router-link
                tag="button"
                v-if="!entry.is_returned"
                :to="{
                                name: 'admin.billing.rentals.renew',
                                params: {
                                    id: entry.id,
                                },
                            }"
                class="btn btn-indigo"
            >Продлить
            </router-link
            >

            <router-link
                tag="button"
                v-if="!entry.is_returned"
                :to="{
                                name: 'admin.billing.rentals.replace',
                                params: {
                                    id: entry.id,
                                },
                            }"
                class="btn btn-warning"
            >Заменить
            </router-link
            >
          </div>

          <button
              v-if="editing && can('remove-rental')"
              @click.prevent="destroy"
              class="btn btn-danger"
          >
            Удалить
          </button>

          <hr class="my-3"/>

          <div class v-if="editing && entry.order_id">
            <button
                :disabled="saving"
                v-if="!entry.order.is_paid"
                @click.prevent="createInvoice"
                class="btn btn-success"
            >
              Сформировать счет
            </button>

            <button
                v-if="!entry.order.is_paid"
                @click.prevent="payOrder"
                class="btn btn-pink"
            >
              Оплатить
            </button>
          </div>
        </form>
      </div>

      <renewals v-if="editing"/>
      <invoices v-if="entry.order_id" :orderId="entry.order_id"/>
      <create-customer-modal
          :show="showCustomerModal"
          @close="showCustomerModal = false"
          @create="createCustomer"
      />
    </div>
  </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";
import CreateCustomerModal from "@/views/admin/customers/modal";
import Renewals from "./renewals";
import Invoices from "./invoices";
import qs from "qs";

export default {
  extends: ResourceForm,

  components: {
    Renewals,
    CreateCustomerModal,
    Invoices,
  },

  data() {
    return {
      canUpdate: this.can("edit-rental"),
      resource: {
        name: "admin.billing.rentals",
        endpoint: "admin/billing/rentals",
      },

      showCustomerModal: false,

      selects: {
        ready: false,
        accounts: [],
        products: [],
        customers: [],
        partners: [],
        sellers: [],
        types: [
          {
            label: 'Аренда ученику',
            value: 'for_pupil'
          },
          {
            label: 'Аренда прорыв (включена в стоимость курса)',
            value: 'for_breakthrough'
          },
          {
            label: 'Аренда инициация (включена в стоимость курса)',
            value: 'for_initiating'
          },
          {
            label: 'Аренда вип абонемент (включена в стоимость курса)',
            value: 'vip_subscription'
          },
          {
            label: 'Аренда партнеру',
            value: 'for_partner'
          }
        ]
      },
    };
  },

  methods: {
    createInvoice() {
      this.saving = true;
      axios
          .post(`/admin/billing/orders/${this.entry.order_id}/invoice`)
          .then((response) => {
            let invoiceId = response.data.data.id;

            this.$message.success("Счет сформирован");
            this.$router.push({
              name: "admin.billing.invoices.show",
              params: {
                id: invoiceId,
              },
            });
          })
          .catch((error) => {
            this.saving = false;
            if (error.response.data.message) {
              this.$message.error(error.response.data.message);
            } else {
              this.$message.error("Произошла ошибка");
            }
          });
    },

    payOrder() {
      axios
          .post(`/admin/billing/orders/${this.entry.order_id}/pay`)
          .then((response) => {
            this.entry.is_paid = true;
            this.$message.success("Аренда оплачена");
          });
    },

    customersFilterBy(model, match, query) {
      return (
          match.indexOf(query) !== -1 ||
          (model.amo_id && model.amo_id.indexOf(query) !== -1) ||
          (model.phone && model.phone.indexOf(query) !== -1)
      );
    },

    productsFilterBy(model, match, query) {
      return (
          match.indexOf(query) !== -1 ||
          (model.unique_id && model.unique_id.indexOf(query) !== -1)
      );
    },

    onFetch() {
      if (
          !this.selects.products.find(
              (product) => product.id === this.entry.product_id
          )
      ) {
        this.selects.products.push(this.entry.product);
      }
    },

    createCustomer(customer) {
      this.selects.customers.push({
        ...customer,
        label: customer.full_name + ", " + customer.phone,
      });
      this.entry.customer_id = customer.id;
      this.showCustomerModal = false;
    },
    returnItem() {
      if (!confirm("Подтвердите действие")) {
        return false;
      }

      axios
          .post("/admin/billing/rentals/" + this.entry.id + "/return")
          .then((response) => {
            this.$message.success("Товар возвращен");

            this.entry.returned_at = response.data.data.returned_at;
            this.entry.is_returned = true;
          })
          .catch((error) => {
            console.log(error.response.data);
          });
    },

    async fetchSelects() {
      await this.fetchCustomers()

      await axios.get("/admin/assets/accounts/all").then((response) => {
        this.selects.accounts = response.data.data;
      });

      await axios
          .get("/admin/products/all", {
            params: {
              filters: {
                rentable: 1,
              },
            },
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          })
          .then((response) => {
            this.selects.products.push(...response.data.data);
          });

      await axios
          .get("/admin/users/all", {
            params: {
              filters: {
                role: "partner",
              },
            },
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          })
          .then((response) => {
            this.selects.partners = response.data.data;
          });

      await axios.get("/admin/users/all").then((response) => {
        this.selects.sellers = response.data.data;
      });

      this.selects.customers.unshift({
        id: -1,
        label: "Добавить клиента",
      });

      this.selects.ready = true;

      if (this.$route.params.productId) {
        this.$set(
            this.entry,
            "product_id",
            this.$route.params.productId
        );
      }
    },
  },

  mounted() {
    this.entry.seller_id = this.$auth.user().id;
    this.fetchSelects();
  },

  watch: {},
};
</script>
